import { render } from "./QuestionViewModal.vue?vue&type=template&id=538f4888&scoped=true"
import script from "./QuestionViewModal.vue?vue&type=script&lang=js"
export * from "./QuestionViewModal.vue?vue&type=script&lang=js"

import "./QuestionViewModal.vue?vue&type=style&index=0&id=538f4888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538f4888"]])

export default __exports__